import { render, staticRenderFns } from "./postsDetail.vue?vue&type=template&id=d3894878&scoped=true"
import script from "./postsDetail.vue?vue&type=script&lang=js"
export * from "./postsDetail.vue?vue&type=script&lang=js"
import style0 from "./postsDetail.vue?vue&type=style&index=0&id=d3894878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3894878",
  null
  
)

export default component.exports